export class NfeService {
  constructor($http, URL_API_NFE) {
    "ngInject";

    this.$http = $http;
    this.URL = URL_API_NFE;
  }

  async busca(clienteId, chaveAcesso) {
    const token = localStorage.getItem('ls.token');
    return this.$http.get(`${this.URL}/v1/nfe?chaveAcesso=${encodeURIComponent(chaveAcesso)}`, {
      headers: {
        Authorization: token,
      },
      responseType: 'json',
      timeout: 10000
    });
  }
}
